import { render, staticRenderFns } from "./NotSupported.vue?vue&type=template&id=04921b95&"
import script from "./NotSupported.vue?vue&type=script&lang=js&"
export * from "./NotSupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports